/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */
import { TFunction } from 'i18next'

export { handleKeyDownClick } from './handleKeyDownClick'

/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
export const getRandomInt = (min: number, max: number) => {
  const minInt = Math.ceil(min)
  const maxInt = Math.floor(max)

  return Math.floor(Math.random() * (maxInt - minInt + 1)) + minInt
}

export interface Dictionary<T> {
  [Key: string]: T
}

export const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max)
}

export const formatOutOfText = (score: number, maxScore: number, t: TFunction): string => {
  return t('outOf', { score, maxScore })
}
